// extracted by mini-css-extract-plugin
module.exports = {"title":"ReplyEditedWarningContainer-title-18328f4b680bb74197cd497eb00e1a71","icon":"ReplyEditedWarningContainer-icon-cfe01c432d0e5449a19cad51314bb1ae"};